<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import {copyObject, setFocusTo} from "../lib/lib";
    import CompanyTransporter from "./CompanyTransporter.svelte";

    let settings = null;

    const load = () => {
        const onSuccess = result => {
            settings = result;
        }

        const onFailure = err => {
        };

        R.handle(R.app.settingsLoad, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {
        const onSuccess = result => {
            settings = result;
            $app.settings = copyObject(settings);
            Notifier.showMessage("Workspace settings updated");
        }

        const onFailure = err => {
        };

        settings.company_name = settings.company_name.trim();
        if (!settings.company_name) {
            Notifier.showError("Type the name of your company!");
            setFocusTo('companyName');
            return;
        }

        R.handle(R.app.settingsEdit, settings, onSuccess, onFailure, LOADER.POPUP);
    }

    const onTransporterChange = ({detail}) => {
        if (detail) {
            settings.transporter_id = detail.id;
            settings.transporter = detail;
        } else {
            settings.transporter_id = 0;
            settings.transporter = null;
        }
    }

    load();
</script>

<PageHeader title="Workspace"/>

{#if settings}
    <div class="row">
        <div class="col-xl-4 col-lg-6">
            <div class="panel border-default mb-5">
                <div class="panel-body panel-pad">
                    <div class="form-group mb-4">
                        <h5>Company name</h5>
                        <input type="text" class="form-control" id="companyName" bind:value="{ settings.company_name }">
                    </div>
                    <!--                    <h6>Colors</h6>-->
                    <!--                    <div class="row">-->
                    <!--                        <div class="col-xl-2 col-lg-3 col-sm-2 col">-->
                    <!--                            <div class="form-group">-->
                    <!--                                <label>Arrival</label>-->
                    <!--                                <input type="color" class="form-control pointer" style="height:38px;"-->
                    <!--                                       bind:value="{ settings.transfer_colors[ROUTE_TYPE.ARRIVAL] }">-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class="col-xl-2 col-lg-3 col-sm-2 col">-->
                    <!--                            <div class="form-group mb-4">-->
                    <!--                                <label>Departure</label>-->
                    <!--                                <input type="color" class="form-control pointer" style="height:38px;"-->
                    <!--                                       bind:value="{ settings.transfer_colors[ROUTE_TYPE.DEPARTURE] }">-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class="col-xl-2 col-lg-3 col-sm-2 col">-->
                    <!--                            <div class="form-group mb-4">-->
                    <!--                                <label>Tour</label>-->
                    <!--                                <input type="color" class="form-control pointer" style="height:38px;"-->
                    <!--                                       bind:value="{ settings.transfer_colors[ROUTE_TYPE.TOUR] }">-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="form-group">-->
                    <!--                        <h6></h6>-->
                    <!--                    </div>-->

                    <div class="form-group">
                        <h6>Transport Company</h6>
                        <CompanyTransporter transporter="{ settings.transporter }" on:change="{ onTransporterChange }"/>
                    </div>

                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-sm-2">
                            <div class="form-group">
                                <h6>Vat (%)</h6>
                                <input type="number" class="form-control" bind:value="{ settings.vat }">
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="text-end">
                        <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}